import PropTypes from 'prop-types';
import { SelectorLabel, SelectorTab, SelectorsContainer } from './TabSelector.style';

const TabSelector = ({ onChange, options, value }) => (
  <SelectorsContainer>
    {options?.map(option => (
      <SelectorTab
        onClick={() => onChange(option)}
        key={option.value}
        isSelected={option.value === value}
      >
        <SelectorLabel>{option.label}</SelectorLabel>
      </SelectorTab>
    ))}
  </SelectorsContainer>
);

TabSelector.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
    }),
  ),
  value: PropTypes.any,
};

export default TabSelector;
